
import { UserConfigService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			extraBookYearsToSearch: UserConfigService.getBrowseSearchSettings().SaleRowsExtraBookYearsToSearch
		};
	},
	props: {
		isPurchase: Boolean
	},
	methods: {
		async save(){
			let settings = UserConfigService.getBrowseSearchSettings();
			if (this.isPurchase) {
				settings.PurchaseDocumentRowExtraBookYearsToSearch = this.extraBookYearsToSearch;
			}else{
				settings.SaleRowsExtraBookYearsToSearch = this.extraBookYearsToSearch;
			}
			await UserConfigService.setBrowseSearchSettings(settings);
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		}
	},
	mounted(){
		if (this.isPurchase) {
			this.extraBookYearsToSearch = UserConfigService.getBrowseSearchSettings().PurchaseDocumentRowExtraBookYearsToSearch;
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-browse"
	}
});
